import { createContext, useContext } from 'react';

const NavPinnedContext = createContext(false);

export const NavPinnedProvider = NavPinnedContext.Provider;

export function useNavPinned(): boolean {
  return useContext(NavPinnedContext);
}
